class ProdutosReportModal {
    static get $inject() {
        return ['$scope', 'gql', 'downloadService']
    }

    constructor($scope, gql, downloadService) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
        this.downloadService = downloadService

        this.cacheKey = "ProdutosReportColumns"

        this.reportOptions = {
            format: 'XLSX',
            selected: []
        }
    }

    $onInit() {
        this.promise = this
            .loadFields()
            .then(fields => this.fields = fields)
            .finally(() => this.apply())
    }

    loadFields() {
        this.isAllSelected = false

        const query = gql`
            query ProdutoReportFields {
                reportFields {
                    fields: produtos {
                        name
                        description
                        optional
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ reportFields: { fields } }) => fields)
    }

    gerarRelatorio() {
        const query = gql`
            query ProdutosReport($filialId: Int!, $format: ReportFormat!, $filter: ProdutoFilter, $order: ProdutoOrder, $fields: [ProdutoReportFieldName!], $next: String) {
                filial(id: $filialId) {
                    id
                    operation: produtosReport(filter: $filter, format: $format, fields: $fields, order: $order, next: $next) {
                        token
                        next
                    }
                }
            }
        `

        const { filialId, order, ...filter } = this.resolve.filter
    
        const selected = this.reportOptions.selected.map(f => f.name)

        this.downloadPromise = this.downloadService
            .resumeOperation(next => {
                const variables = {
                    fields: selected,
                    filialId: parseInt(filialId),
                    filter: filter,
                    format: this.reportOptions.format,
                    order: order,
                    next: next
                }

                return this.gql
                    .query(query, variables)
                    .then(({ filial: { operation } }) => operation)
            })
            .then(() => localStorage.setItem(this.cacheKey, JSON.stringify(selected)))
            .finally(() => this.apply())
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('produtosReportModal', {
        controller: ProdutosReportModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal modal-title="Exportação de produtos" close="$ctrl.close">
            <modal-body>                                
                <highlighted>
                    <main>Exportação de produtos</main>
                    <secondary>Selecione abaixo o formato do arquivo e os campos que serão exportados.</secondary>
                </highlighted>                
                
                <loading promise="$ctrl.promise">
                    <ef-report-options-selector 
                        cache-as="$ctrl.cacheKey" 
                        fields="$ctrl.fields"
                        ng-model="$ctrl.reportOptions">
                    </ef-report-options-selector>
                </loading>
            </modal-body>

            <modal-footer>
                <promise-tracker promise="$ctrl.downloadPromise" active="$ctrl.isLoading">
                    <button class="btn btn-primary" disabled ng-show="$ctrl.isLoading">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Exportando...
                    </button>
                    <button class="btn btn-primary" ng-click="$ctrl.gerarRelatorio()" ng-hide="$ctrl.isLoading">Exportar</button>
                    <button class="btn btn-default" ng-click="$ctrl.close()" ng-disabled="$ctrl.isLoading">Fechar</button>
                </promise-tracker>
            </modal-footer>
        </modal>
        `
    })
